import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../../core/services/cra-esn/cra-esn.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, finalize, takeUntil } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { serverError } from './../../../../../core/models/messages';
import { CandidatService } from '@core/services/candidat-service/candidat.service';
import * as saveAs from 'file-saver';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CraSelectedService } from '@core/services/cra-esn/cra-selected.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-detail-cra',
  templateUrl: './detail-cra.component.html',
  styleUrls: ['./detail-cra.component.css'],
})
export class DetailCraComponent {
  holidays: string[] = [];
  currentDate: Date = new Date();
  selectedValues: any[] = [];
  allSelectedValues: any[] = [];
  listOfCra: any;
  idCra: any;
  custom_role_id: any;
  listDetailsCraForMonths: any;
  totalTypeOfCra: any;
  rowIndex!: number;
  numberOfDays!: number;
  addCraData: any;
  totalClientOfCra: any;
  listClientOfCra: any;
  durationCra: any;
  typeIds: any = [];
  totalDurations: any[] = [];
  totalDurationByfamilyByType: any;
  totalDurationForAllFamilies: any;
  type_id!: number;
  unknownFamily: boolean = false;
  unknownType: boolean = false;
  currentUser: any;
  companyId: any;
  userId: any;
  id: any;
  res = [
    { id: 1, name: '0.25' },
    { id: 2, name: '0.5' },
    { id: 3, name: '0.75' },
    { id: 4, name: '1' },
  ];

  testArray: any = [1, 2, 3];
  modelSlect = '1';
  modalRef?: BsModalRef;
  rejectForm: FormGroup = this.createRejectForm();
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();

  selectedCra: any = null
  constructor(
    private serviceCra: CraEsnService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private candidatService: CandidatService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private craSelectedService: CraSelectedService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyId = this.localStorageService.getData('clientConnected');
    this.userId = JSON.parse(this.currentUser)?.uuid
    this.getId()
    this.getCandidateById()
  }
  selectedCandidate: any;
  getCandidateById() {
    this.spinner.show();
    this.candidatService
      .getUserById(this.userId)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.selectedCandidate = res.data;
          this.getListTypeOfCra();
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }
  
  getListTypeOfCra() {
    this.spinner.show();
    this.serviceCra
      .getListTypeOfCra(this.idCra)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('getListTypeOfCra res', res);
          if (res?.data?.items && Array.isArray(res.data.items)) {
            this.listOfCra = res.data.items;
            this.typeIds = this.listOfCra.map((type:any) => type.id); // Map simplifié  
          }
          this.totalTypeOfCra = res?.data?.count ?? 0;
        },
        error: () => {
        },
        complete: () => {
          this.spinner.hide();
        },
      });
  }
  
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idCra = params.params['idCra'];
        this.custom_role_id = params.params['roleId'];
        if (this.craSelectedService.hasCRASelected()) {
          this.selectedCra = this.craSelectedService.getCRASelected()          
          if(this.idCra != this.selectedCra?.id){
            this.selectedCra = null
          }
          this.getDetailsListCra(this.idCra);
          this.getlistClientOfCra(this.idCra);
        }
        else{
          this.router.navigateByUrl('/cra');
        }        
      },
      error: (err) => {
      },
    });
  }
  getDetailsListCra(idCra: any) {
    this.spinner.show();
    this.serviceCra
      .getDetailsCraJourfeerie(idCra)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe({
        next: (res: any) => {
          this.listDetailsCraForMonths = res?.data;
  
          if (this.listDetailsCraForMonths?.desiredCRA?.ligne_cra && Array.isArray(this.listDetailsCraForMonths.desiredCRA.ligne_cra)) {
            const numberOfRows = Number(this.numberOfRows);
            const numberOfDays = Number(this.listDetailsCraForMonths?.numberOfDays);
            this.selectedValues = Array.from({ length: numberOfRows }, () => Array.from({ length: numberOfDays }, () => null));
  
            for (const cra of this.listDetailsCraForMonths.desiredCRA.ligne_cra) {
              const type_id = cra.type_id;
              for (const day of cra.days) {
                const dayIndex = day.day - 1;
                const duration = day.duration ? parseInt(day.duration) : null;
  
                if (!this.selectedValues[type_id]) {
                  this.selectedValues[type_id] = [];
                }
                this.selectedValues[type_id][dayIndex] = { duration };
              }
            }
          }
          if (this.listDetailsCraForMonths?.desiredCRA?.total_duration_by_day && Array.isArray(this.listDetailsCraForMonths.desiredCRA.total_duration_by_day)) {
            for (const totalDuration of this.listDetailsCraForMonths.desiredCRA.total_duration_by_day) {
              const dayIndex = totalDuration.day - 1;
              this.totalDurations[dayIndex] = totalDuration.total_duration;
            }
          }
          this.totalDurationByfamilyByType = this.listDetailsCraForMonths?.desiredCRA?.totalDurationByfamilyByType ?? [];
          this.totalDurationForAllFamilies = this.listDetailsCraForMonths?.desiredCRA?.totalDurationForAllFamilies ?? {};
        },
        error: (error) => {
        },
      });
  }

  getTotalDurationByType(familyId: string): any[] {
    const family = this.totalDurationByfamilyByType?.find(
      (fam: any) => fam.family_id === familyId
    );
    return family ? family.types : [];
  }

  getlistClientOfCra(idCra: any) {
    this.spinner.show();
    this.serviceCra
      .getClientsByCandidate(this.selectedCra?.consultant_e_s_n?.candidate?.uuid, idCra)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {          
          this.listClientOfCra = res.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
 
  getTypeName(typeId: number): string | undefined {
    return (
      this.totalDurationByfamilyByType &&
      this.totalDurationByfamilyByType[typeId]?.[0]?.type_name
    );
  }


  generateDaysArray(): number[] {
    return Array.from(
      { length: this.listDetailsCraForMonths?.numberOfDays },
      (_, index) => index + 1
    );
  }

  get numberOfRows(): number[] {
    return Array.from({ length: this.totalTypeOfCra }, (_, index) => index + 1);
  }

  isWeekend(day: number): boolean {
    if (
      !this.listDetailsCraForMonths?.weekends ||
      this.listDetailsCraForMonths.weekends.length === 0
    ) {
      return false;
    }

    const firstWeekendDate = this.listDetailsCraForMonths.weekends[0];
    const yearMonth = firstWeekendDate.substring(0, 7);

    const dayString = day < 10 ? `0${day}` : `${day}`;
    const formattedDate = `${yearMonth}-${dayString}`;

    return this.listDetailsCraForMonths.weekends.includes(formattedDate);
  }
  isHoliday(day: number): boolean {
    if (
      !this.listDetailsCraForMonths?.holidays ||
      this.listDetailsCraForMonths.holidays.length === 0
    ) {
      return false;
    }

    const firstWeekendDate = this.listDetailsCraForMonths.holidays[0];
    const yearMonth = firstWeekendDate.substring(0, 7);

    const dayString = day < 10 ? `0${day}` : `${day}`;
    const formattedDate = `${yearMonth}-${dayString}`;

    return this.listDetailsCraForMonths.holidays.includes(formattedDate);
  }
  private pad(n: number): string {
    return n < 10 ? '0' + n : '' + n;
  }
  selectedValuesControls: { [key: number]: FormControl[] } = {};

  // Initialisez les contrôles de formulaire
  initializeFormControls() {
    this.listDetailsCraForMonths?.desiredCRA?.ligne_cra.forEach((cra: any) => {
      this.selectedValuesControls[cra.type_id] = cra.days.map(
        () => new FormControl()
      );
    });
  }
  updateSelectedValue(value: any, type_id: number, day: number) {
    if (!this.selectedValues[type_id]) {
      this.selectedValues[type_id] = Array.from(
        { length: this.listDetailsCraForMonths.numberOfDays },
        () => null
      );
    }
    this.selectedValues[type_id][day] = value;

    // Assume listOfCra is an array with objects having id and other properties
    this.allSelectedValues.push({
      type_id: type_id,
      duration: value,
      day: day + 1, // Adjust day index to start from 1
    });

    let data = {
      date: this.listDetailsCraForMonths?.desiredCRA?.date,
      projectCandidate_id:
        this.listDetailsCraForMonths?.desiredCRA?.projectCandidate_id,
      ligneCra: this.allSelectedValues,
    };
    this.addCraData = data;
  }

  remplirLigne(typeId: number): void {
    const rowIndex =
      this.listDetailsCraForMonths?.desiredCRA?.ligne_cra.findIndex(
        (cra: any) => cra.type_id === typeId
      );

    if (rowIndex !== -1) {
      this.listDetailsCraForMonths?.desiredCRA?.ligne_cra[
        rowIndex
      ].days.forEach((day: any) => {
        day.duration = 1;
      });
    }
  }

 /**
 * Exports the CRA (Compte Rendu d'Activité) for a specific month and country as a PDF file.
 * The generated file is automatically downloaded to the user's system.
 * 
 * @throws {Error} Displays a user-friendly error message if the export fails.
 */
   exportCra() {
    this.spinner.show();
    const EXTENSION = ".pdf"
    const COUNTRY = "FR"
    this.spinner.show()
    this.serviceCra.exportCra(this.listDetailsCraForMonths?.desiredCRA?.id, COUNTRY).subscribe({
      next: (res: any) => {
        const blob = new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
  
        let fileName = this.listDetailsCraForMonths?.desiredCRA?.name
        fileName = fileName.concat(EXTENSION)
  
        saveAs(blob, fileName);
        this.spinner.hide();
        this.toastr.success('CRA téléchargé avec succès');
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(serverError);
      },
    });
    }

  getClassForDuration(duration: number): string {
    switch (duration) {
      case 1:
        return 'duration-1';
      case 4:
        return 'duration-4';
      case 2:
        return 'duration-2';
      default:
        return 'default-duration';
    }
  }
  rejectCra() {
    let data = {
      cra_id: this.idCra,
      custom_role_id: this.custom_role_id,
      state: '2',
    };
    this.serviceCra
      .rejectAndValidateCra(data, this.companyId, this.userId)
      .subscribe({
        next: (res: any) => {
          this.toastr.success('Cra a été rejeté avec succès.');
        },
        error: (error) => {
          this.toastr.error(serverError);
        },
      });
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

   createRejectForm(data?: any) {
      return this.formBuilder.group({
        report: [data && data.report, Validators.required],
        esn_id: [this.localStorageService.getData('clientConnectedName')],
      });
    }

  closeModal() {
    this.modalRef?.hide();
    this.rejectForm.reset();
  }

  /**
   * This method allows to  validate, cancel and reject CRA
   * @param idCra CRA identifier
   * @param type state [2: Envoyé, 3 : Validé, 4 : Rejeté]
   * @param cancel true if it's a cancel operation
  */
  validateCra(type : string | null, cancel?: boolean) {
    let data = {
      cra_id: this.idCra,
      state: type, // state [2: Envoyé, 3 : Validé, 4 : Rejeté]
      report: null,
      rejected: cancel
    };
    let notifMessage = ''
    let confirmationMessage = ''
        if(type === '4'){
          data.report = this.rejectForm?.get('report')?.value
          notifMessage = 'CRA a été rejeté avec succès.'
        } else if(type === '3'){
          notifMessage = 'CRA a été validé avec succès.'
          confirmationMessage = 'Voulez-vous vraiment valider ce CRA ?'
        } else if(cancel){
          notifMessage = 'CRA a été annulé avec succès.'
          confirmationMessage = 'Voulez-vous vraiment annuler ce CRA ?'
        }

    if(type === '4'){
      this.craValidation(data, notifMessage)
    }else{
      Swal.fire({
        title: confirmationMessage,
        icon: 'info',
        iconColor : '#265d91',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Confirmer',
        confirmButtonColor: '#265d91',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.craValidation(data, notifMessage)
        }
      });
    }
    
  }

  displayValidationBtn(): boolean{

    if(this.selectedCra){
      let isValidRole = false
      const currentUser = JSON.parse(this.currentUser)
      if(currentUser.employee_role_id === null)  isValidRole = this.getWorkflowStepName(this.selectedCra) === "admin"
      else isValidRole = currentUser.employee_role_id === this.selectedCra?.nextRoleId
      return [2, 3].includes(this.selectedCra?.status) && isValidRole
    } else{
      return false
    }
  }

  displayCancelBtn(): boolean{
    let canCancel = false
    if(this.selectedCra?.history_cra?.length > 0 && this.selectedCra.status == 3) {
      const currentUser = JSON.parse(this.currentUser)    
      canCancel = currentUser.id == this.selectedCra?.history_cra[0]?.validated_by
      return canCancel
    } else return false
  }

  getWorkflowStepName(cra: any): string{
    const roleName = cra?.nextRoleName
     return roleName ? roleName.replace(/_company\d*$/, '') : 'Consultant'
  }

  private craValidation(data: any, notifMessage : string){
    this.serviceCra
    .validateOrRejectCra(data)
    .subscribe({
      next: (res: any) => {
        this.toastr.success(notifMessage);
        this.router.navigateByUrl('/cra');
      },
      error: (error) => {
        this.toastr.error(serverError);
      },
    });
  }

  getBackgroundColor(input: any): string {
    if (typeof input === 'string') {
      const colorMap: { [key: string]: string } = {
        Production: 'rgb(252 228 236 / 41%)',
        Interne: 'rgb(232 245 233 / 66%)',
        Absence: 'rgb(224 247 250 / 48%)',
      };
      return colorMap[input] || '#ffffff';
    } else if (input?.day) {
      return this.isWeekend(input.day)
        ? '#FDEFEE'
        : this.isHoliday(input.day)
        ? '#f4587a'
        : '';
    }
    return '#ffffff';
  }

  getVisibility(day: any): string {
    return !this.isWeekend(day.day) && !this.isHoliday(day.day)
      ? 'visible'
      : 'hidden';
  }
  getTotalCellStyles(dayIndex: number, total: number) {
    const day = dayIndex + 1;
    const isWeekendDay = this.isWeekend(day);
    const isHolidayDay = this.isHoliday(day);

    const backgroundColor = isWeekendDay
      ? '#FDEFEE'
      : isHolidayDay
      ? '#f4587a'
      : '';
    const visibility = !(isWeekendDay || isHolidayDay) ? 'visible' : 'hidden';

    return {
      'background-color': backgroundColor,
      color: this.getTotalColor(total),
      visibility: visibility,
    };
  }
  getTotalColor(total: number): string {
    if (total === 1) {
      return 'green';
    } else if (total < 1) {
      return 'red';
    }
    return 'black';
  }

}
